export enum LocalStorageKeys {
    UserAppSettings = 'UserAppSettings',
    SessionData = 'SessionData',
}
